import { routes } from "app/routes";
import { NavLink } from "features/navigation/NavLink";
import { useLogEventOnLoad } from "hooks/useLogEventOnLoad";

export const GenericErrorMessage = (props: { alternateInstruction?: string }) => {
    useLogEventOnLoad("generic.error.message", {
        page: window.location.pathname,
    });

    return (
        <>
            Whoops. Something went wrong on our end.{" "}
            {props.alternateInstruction ?? "Please try again or"}
            <NavLink to={routes.contactUs()}> get in touch with us</NavLink>.
        </>
    );
};
